import { Box, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router'

export const NotFound = () => {
  const navigate = useNavigate()
  const theme = useTheme()

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
      <Box
        sx={{
          width: '100%',
          position: 'absolute',
          top: 'min(6rem, 10vh)',
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          pt: { xs: 12, sm: 8, md: 6 },
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            maxWidth: 600,
            px: 3,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              marginBottom: 2,
              textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
              fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
              fontWeight: 700,
              color: theme.palette.text.primary,
              mb: 3,
            }}
          >
            Whoops! This is not what you were looking for
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontSize: '1.5rem',
              marginBottom: 4,
              color: theme.palette.text.secondary,
              mb: 4,
              lineHeight: 1.6,
            }}
          >
            Try your luck by going back to the{' '}
            <Box
              component="span"
              onClick={handleGoHome}
              sx={{
                color: 'primary.main',
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'primary.dark',
                },
              }}
            >
              home page
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
